import { combineReducers } from 'redux';
import { firebaseReducer } from 'react-redux-firebase';
import { firestoreReducer } from 'redux-firestore';

import { reducer as notifications } from 'modules/notification';
import { reducer as project } from 'modules/project';
import locationReducer from './location';

export function makeRootReducer(asyncReducers) {
  return combineReducers({
    // Add sync reducers here
    firebase: firebaseReducer,
    firestore: firestoreReducer,
    notifications,
    projectData: project,
    location: locationReducer,
    ...asyncReducers
  });
}

export function injectReducer(store, { key, reducer }) {
  store.asyncReducers[key] = reducer;
  store.replaceReducer(makeRootReducer(store.asyncReducers));
}

export default makeRootReducer;
